//see webpack config - DefinePlugin
/* eslint-disable */
import cookie from "js-cookie";
import checkTerritory from "./checkTerritory";

const MAILRU = "mailru";
const MYGAMES = "mygames";

class Environment {
  constructor() {
    this.project = process.env.VUE_APP_PROJECT;
    this.region = process.env.VUE_APP_TERRITORY;
    this.minigame = process.env.VUE_APP_MINIGAME;
    this.language = cookie.get("cur_language");
    this.default_languages = {
      ru: "ru",
      eu: "en",
    };
    this.territory = this.getTerritory();
  }
  /* eslint-enable */
  isMailRu() {
    return this.territory === MAILRU;
  }
  isMyGames() {
    return this.territory === MYGAMES;
  }
  getProject() {
    return this.project;
  }
  getRegion() {
    return this.region;
  }
  getMinigame() {
    return this.minigame;
  }
  getLang() {
    if (this.language) {
      return this.language;
    }
    return this.default_languages[this.getRegion()];
  }
  getTerritory() {
    if (location.origin.indexOf("localhost") > -1) {
      this.territory = MAILRU;
    }
    const url_host = window.location.host.split(".");
    const isRuTerritory = checkTerritory("ru", url_host);

    if (isRuTerritory) {
      this.territory = MAILRU;
    } else {
      this.territory = MYGAMES;
    }
    return this.territory;
  }
  getPosixLocale() {
    const locales = {
      en: "en_US",
      de: "de_DE",
      fr: "fr_FR",
      ru: "ru_RU",
      es: "es_ES",
      cn: "zh_CN",
      pl: "pl_PL",
    };
    return locales[this.getLang()];
  }
}
export default new Environment();
